import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import entry1 from '@/assets/entry1.png';
import entry2 from '@/assets/entry2.png';
import entry3 from '@/assets/entry3.png';
import button1 from '@/assets/button1.png';
import button2 from '@/assets/button2.png';
import button3 from '@/assets/button3.png';

const arrList = [
  {
    poster: entry1,
    name: 'All Products',
    path: '/mall/AllProducts',
    btnimg: button1,
  },
  {
    poster: entry2,
    name: 'IchibanKuji',
    path: '/mall/IchibanKujiOnline',
    btnimg: button2,
  },
  {
    poster: entry3,
    name: 'HexaKuji',
    path: '/mall/HexaKujiOnline',
    btnimg: button3,
  },
];
const Entry: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.entry}>
      {arrList.map((item) => (
        <div
          key={item.path}
          className={styles.item}
          onClick={() => navigate(item.path)}
        >
          <div className={styles.inner}>
            <img src={item.poster} alt="poster" className={styles.poster} />
            <span className={styles.name}>{item.name}</span>
            <img src={item.btnimg} alt="button" className={styles.btn} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Entry;
